/**
 * @generated SignedSource<<916c36b5b3e090395dde8f8a756c0621>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftExhibitionsLayout_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftExhibitionsGrid_viewer">;
  readonly " $fragmentType": "NftExhibitionsLayout_viewer";
};
export type NftExhibitionsLayout_viewer$key = {
  readonly " $data"?: NftExhibitionsLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftExhibitionsLayout_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftExhibitionsLayout_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftExhibitionsGrid_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "517e345ec0fb29f4f82bb2b2c15639fe";

export default node;
